<template>
  <footer class="footer">
    <div class="container footer-container">
      <nav class="menu">
        <router-link to="/" class="menu-item">
          <HomeIcon class="menu-item__icon" />
          <div class="menu-item__text">Главная</div>
        </router-link>
        <router-link to="/lib" class="menu-item">
          <LibIcon class="menu-item__icon" />
          <div class="menu-item__text">Библиотека</div>
        </router-link>
        <router-link to="/lk" class="menu-item">
          <LkIcon class="menu-item__icon" />
          <div class="menu-item__text">Личный кабинет</div>
        </router-link>
        <div class="menu-item" @click="$emit('modal', 'callback')">
          <CallbackIcon class="menu-item__icon" />
          <div class="menu-item__text">Обратная связь</div>
        </div>
      </nav>
    </div>
  </footer>
</template>

<script>
import HomeIcon from '@/components/icons/HomeIcon.vue';
import LibIcon from '@/components/icons/LibIcon.vue';
import LkIcon from '@/components/icons/LkIcon.vue';
import CallbackIcon from '@/components/icons/CallbackIcon.vue';

export default {
  name: 'FooterBlock',
  components: {
    HomeIcon,
    LibIcon,
    LkIcon,
    CallbackIcon,
  },
};
</script>

<style scoped lang="scss">
.footer {
  position: fixed;
  background-color: var(--color-white-opacity);
  color: var(--color-gray);
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 90;

  &-container {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .menu {
    width: 100%;
    display: flex;
    padding-top: 6px;
    padding-bottom: 10px;
    &-item {
      width: 25%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      gap: 6px;
      padding: 8px 4px;
      color: var(--color-gray);
      cursor: pointer;
      &.active {
        color: var(--color-blue);
      }
      &__text {
        height: 24px;
        text-align: center;
        font-size: 10px;
        font-style: normal;
        font-weight: 600;
        line-height: 120%;
        color: currentColor;
        transition: 0.3s color;
      }
      &__icon {
        width: 20px;
        height: 20px;
        min-width: 20px;
        min-height: 20px;
        color: currentColor;
        transition: 0.3s color;
      }
    }
  }
}
</style>
